module.exports = __webpack_public_path__ + "img/login_message_close.bc59c897.svg";